<div 
  class="custom-route__all-ready"
  [class.hidden]="!allReadyView()"
>
  <p class="all-ready__title ci-heading-h4-bold">
    ¡{{ 'Todo listo' | translate }}!
  </p>
  <p class="all-ready__subtitle ci-paragraph-p1-regular">
    {{ 'Disfruta de tu ruta' | translate }}
  </p>
</div>

<section 
  class="custom-route__welcome-planner-view"
 [class.shown]="!allReadyView()" 
>
  <header class="welcome-planner-view__header">
    <h1 class="welcome-planner-view__title ci-heading-h2-bold">
      {{ 'Te damos la bienvenida al planificador' | translate }}
    </h1>
    <p class="welcome-planner-view__subtitle ci-paragraph-p1-semibold">
      {{ 'Aquí encontrarás todos los lugares que Cicerone ha seleccionado para ti, organizados en una práctica línea de tiempo para que tu recorrido sea más fácil de seguir' | translate }}
    </p>
  </header>
  
  <main class="welcome-planner-view__main">
    <ul class="welcome-planner-view__items">
      <li class="welcome-planner-view__item">
        <ci-icon 
          class="welcome-planner-view__icon"
          type="svg" 
          name="navigation" 
          scale="1.5x"
        ></ci-icon>
        <p class="welcome-planner-view__item-text ci-paragraph-p1-regular">
          <strong>{{ 'Empieza tu viaje' | translate }}</strong>
          {{ 'con el botón “Comenzar Ruta”' | translate }}
        </p>
      </li>
      
      <li class="welcome-planner-view__item">
        <ci-icon 
          class="welcome-planner-view__icon"
          type="svg" 
          name="type" 
          scale="1.5x"
        ></ci-icon>
        <p class="welcome-planner-view__item-text ci-paragraph-p1-regular">
          <strong>{{ 'Personaliza tu día' | translate }}</strong>
          {{ 'editando los recursos pulsando en el botón “Editar Ruta”' | translate }}
        </p>
      </li>
      
      <li class="welcome-planner-view__item">
        <ci-icon 
          class="welcome-planner-view__icon"
          type="svg" 
          name="ticket" 
          scale="1.5x"
        ></ci-icon>
        <p class="welcome-planner-view__item-text ci-paragraph-p1-regular">
          <strong>{{ 'Muévete sin complicaciones' | translate }}</strong> 
          {{ 'adquiriendo un abono transporte postpago de' | translate }} <strong> MPass </strong>
          {{ 'para usar el transporte público' | translate }}
        </p>
      </li>
    </ul>
  </main>

  <footer class="welcome-planner-view__footer">
    <ci-button
      class="welcome-planner-view__button ci-btn-primary-s-filled"
      type="button"
      (click)="handleGoToPlannerClick()"
    >
      {{ 'Ir al planificador' | translate }}
    </ci-button>
  </footer>
</section>
